<template>
  <div class="app-step-one">
    <div class="page-container">
      <div class="app-step-one__row">
        <div
          class="app-step-one__col app-step-one-left"
          :class="{ notHome: !isHome }"
        >
          <h1 class="app-step-one-left__title title">
            SMART PRESS RELEASE DISTRIBUTION
          </h1>

          <div class="app-step-one-left__addition-info" v-if="!isHome">
            <h3>
              Writing can be added to any distribution for an additional fee.
            </h3>
            <ul>
              <li v-for="(item, index) in formattedDescription" :key="index">
                {{ item }}
              </li>
            </ul>
          </div>

          <loading-bar v-if="isLoading"></loading-bar>
          <step-one-package-groups
            v-else-if="showPackageGroups"
            :package-groups="packageGroups"
          ></step-one-package-groups>
          <step-one-form
            v-else-if="isHome || hasPackageData"
            :packageItem="packageItem"
          ></step-one-form>
        </div>
        <div
          v-if="isHome && !showPackageGroups"
          class="app-step-one__col app-step-one-right"
        >
          <step-one-prices></step-one-prices>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useSpecialPackage } from './useSpecialPackage'
import { usePackageGroups } from '@core/composables/usePackageGroups'
import { useAuthStore } from '@/stores/auth'

import LoadingBar from '@modules/ui/loading-bar.vue'
import StepOneForm from './form.vue'
import StepOnePackageGroups from './package-groups.vue'
import StepOnePrices from './prices.vue'
import { useRoute } from 'vue-router'
import { computed, onMounted, unref, watch } from 'vue'

const route = useRoute()
const authStore = useAuthStore()

const isHome = computed(() => route.name === 'home')

const { packageItem, isLoading: isSpecialPackageLoading } = useSpecialPackage()
const hasPackageData = computed(() => Boolean(packageItem?.id))
const {
  packageGroups,
  hasPackageGroupPackages,
  isPackageGroupsLoading,
  getPackageGroups,
} = usePackageGroups()

const showPackageGroups = computed(
  () => isHome.value && authStore.isLoggedIn && hasPackageGroupPackages.value
)

const isLoading = computed(() => {
  if (unref(isSpecialPackageLoading)) return true

  return isHome.value && authStore.isLoggedIn && isPackageGroupsLoading.value
})

const fetchPackageGroupsIfNeeded = () => {
  if (isHome.value && authStore.isLoggedIn) {
    getPackageGroups()
  }
}

onMounted(fetchPackageGroupsIfNeeded)

watch([isHome, () => authStore.isLoggedIn], fetchPackageGroupsIfNeeded)

const formattedDescription = computed(() => {
  return packageItem?.description?.split('\r\n')
})
</script>
